import useApi from '../use-api';

const getUrl = (patientGuid: string) =>
  `admins/admin-panel/patients/${patientGuid}/apcm-consent`;

export const useApcmConsentForm = () => {
  const { loading, createData } = useApi();

  const consentForm = async (patientGuid: string, isAgree: boolean) => {
    const url = getUrl(patientGuid);
    await createData(url, {
      isAgree,
    });
  };

  return {
    loading,
    consentForm,
  };
};
